import React, {FC} from "react";
import {BoxStyled, ButtonStyled} from "@/components/Button/styled";
import Image from "next/legacy/image";
import {imageLoader} from "@/utils";
import {IButton} from "@/components/Button/type";
import {Checkbox} from "@/icons";

const Button: FC<IButton> = ({children, ...props}) => {
    return (
        <BoxStyled p={props.p}>
            <ButtonStyled {...props}>
                {props.active && (
                    <span>
                        <Image src={Checkbox} width={18} height={18} loader={imageLoader} alt="Vodafone Ev interneti"/>
                    </span>
                )}
                {children}
            </ButtonStyled>
        </BoxStyled>
    )
}
export default Button;
